export default "__VITE_ASSET__$DiX3ypp__"